export const GREEDY_FEE = {
  nickname: 'PRODUCTS.GREEDY_FEE.nickname',
  properties: [],
  icon:'greedy-fee'
};
